<template>
  <div>
    <p v-if="label" class="global-navi-title">{{label}}</p>
    <p v-else-if="separator" class="global-navi-title global-navi-separator"></p>
    <ul>
      <li v-for="menuItem in mainMenuItems" :key="menuItem.label">
        <component :is="menuItem" :ref="menuItem.name" :active="active" />
      </li>
      <li v-if="expandable">
        <ul v-if="expanded">
          <li v-for="menuItem in extraMenuItems" :key="menuItem.label">
            <component :is="menuItem" :ref="menuItem.name" />
          </li>
        </ul>
        <a class="global-navi-btn-accordion global-navi-arrow-accordion-close" v-if="expanded" @click="expanded = false">メニューを閉じる</a>
        <a class="global-navi-btn-accordion global-navi-arrow-accordion-open" v-else @click="expanded = true">メニューをもっとみる</a>
      </li>
    </ul>
  </div>
</template>

<script>
import SideMenuItem from './side-menu-item';

const MAX_COUNT = 99;

export default {
  name      : 'side-menu-group',
  components: {
    SideMenuItem,
  },
  props: {
    active: {
      type   : Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      label    : '',
      limit    : MAX_COUNT,
      menuItems: [],
      expanded : false,
      separator: false,
    };
  },
  computed: {
    expandable: function() {
      return this.limit < this.menuItems.length;
    },
    mainMenuItems: function() {
      return this.menuItems.slice(0, this.limit);
    },
    extraMenuItems: function() {
      return this.menuItems.slice(this.limit);
    },
  },
  watch: {
    active: function() {
      this.expanded = false;
    },
  },
  updated: function() {
    this.$emit('content-changed');
  },
  methods: {
    findMenuItem: function(name) {
      if (!name) {
        return;
      }
      const item = this.$refs['side-menu-item-' + name];
      if (item) {
        // Vueの仕様でv-forでループしているので配列になっている
        return item[0];
      }
    },
  },
};
</script>
